<igx-grid #parentsGrid primaryKey="id" [data]="this.parents | sorting" igxGridState [moving]="true" (columnMoving)="columnMoving($event)">
    <igx-grid-toolbar>
        <igx-grid-toolbar-actions>
            <button igxButton igxRipple (click)="addParent(dialog)">Добави родител</button>
        </igx-grid-toolbar-actions>
    </igx-grid-toolbar>
    <igx-column width="65px" [editable]="false" [resizable]="false" [pinned]="true">
        <ng-template igxCell let-cell="cell">
            <button title="Редактирай" igxIconButton="flat" (click)="updateParent(cell)">
                <igx-icon>edit</igx-icon>
            </button>
        </ng-template>
    </igx-column>
    <igx-column field="name" header="Име" [sortable]="true" [disablePinning]="true" [resizable]="true"></igx-column>
    <igx-column field="email" header="Имейл" [sortable]="true" [disablePinning]="true" [resizable]="true"></igx-column>
    <igx-column field="phone" header="Телефон" [sortable]="true" [disablePinning]="true" [resizable]="true"></igx-column>
    <igx-column field="parentType" header="Тип" [sortable]="true" [disablePinning]="true" [resizable]="true"></igx-column>
    <igx-column field="kids" header="Деца" [sortable]="true" [disablePinning]="true" [resizable]="true">
        <ng-template igxCell let-cell="cell">
            {{ parseKids(cell.value) }}
        </ng-template>
    </igx-column>
</igx-grid>
<igx-dialog #dialog>
    <igx-dialog-title>{{ dialogText }} родител</igx-dialog-title>
    <app-edit-parent-form [parent]="editParent" (done)="saveParentDone($event)"></app-edit-parent-form>
</igx-dialog>